import Layout from '../layout/Layout'
import SEO from '../components/SEO/SEO'

const Rewards = () => {
  return (
    <>
      <SEO />
      <Layout>
        <div className="relative">
          <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gray-100" />
          <div className="mx-auto">
            <div className="relative">
              <div className="absolute inset-0">
                <img
                  className="h-full w-full object-cover"
                  src="yoga-background.png"
                  alt="Person doing yoga outdoors"
                />
              </div>
              <div className="relative px-4 py-16 md:py-16 lg:py-32 max-w-screen-xl mx-auto">
                <h1 className="text-3xl md:text-5xl tracking-tight text-darkBlue">
                  Earn up to $1,000 annually{' '}
                  <span className="text-globeGreen">with Evry Rewards</span>
                </h1>
                <p className="mt-6 max-w-lg text-xl text-grey sm:max-w-3xl">
                  No more confusing point systems. Evry&#39;s activity-based
                  reward program lets you earn rewards in a number of ways
                  ranging from nutrition education to participating with various
                  Evry provided wellness vendors.
                </p>
              </div>
            </div>
          </div>
        </div>

        <section className="max-w-screen-xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-24 py-32 px-6 md:px-0">
            <div>
              <h2 className="text-4xl text-darkBlue pb-4">
                We make it simple to earn rewards
              </h2>
              <p className="text-grey">
                Earn money by just signing up, meeting your care guide, starting
                an exercise program and linking your wearable device. Points add
                up fast when you&#39;re having fun!
              </p>
            </div>
            <div>
              <h2 className="text-4xl text-darkBlue pb-4">
                Rewards you can actually use
              </h2>
              <p className="text-grey">
                Redeem your rewards with a large list of approved products
                including essential groceries, baby care, over-the-counter
                medication, diabetes and eye care, and personal hygiene
                products.
              </p>
            </div>
            <div>
              <h2 className="text-4xl text-darkBlue pb-4">
                Redeem at 62,000+ retailers nationwide
              </h2>
              <p className="text-grey">
                You don&#39;t have to look far to find a retailer to redeem your
                rewards points. Participating retailers include Walmart, H-E-B,
                Kroger, CVS Pharmacy, Family Dollar, Albertsons, Walgreens, and
                many more.
              </p>
            </div>
          </div>
        </section>
      </Layout>
    </>
  )
}

export default Rewards
